export * from './visuals.pipe';
